import { useThemeColor } from '@hooks/useThemeColor'
import { useEffect, useRef } from 'react'
import { Animated } from 'react-native'
import { View } from 'tamagui'

interface IHamburgerMenuProps {
  size: number
  strokeWidth: number
  animationDuration: number
  isOpen: boolean
}

export const HamburgerMenu = ({
  size,
  strokeWidth,
  animationDuration,
  isOpen,
}: IHamburgerMenuProps) => {
  const color = useThemeColor('icon-primary')
  const animatedValue = useRef(new Animated.Value(0)).current

  useEffect(() => {
    Animated.timing(animatedValue, {
      toValue: isOpen ? 1 : 0,
      duration: animationDuration,
      useNativeDriver: true,
    }).start()
  }, [isOpen, animatedValue, animationDuration])

  const barHeight = strokeWidth
  const gap = 4

  // Animações para cada barra
  const topBarRotation = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '45deg'],
  })

  const topBarTranslateY = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [0, gap + barHeight],
  })

  const middleBarOpacity = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [1, 0],
  })

  const bottomBarRotation = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '-45deg'],
  })

  const bottomBarTranslateY = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [0, -(gap + barHeight)],
  })

  const barStyle = {
    width: size,
    height: barHeight,
    backgroundColor: color,
    borderRadius: barHeight / 2,
  }

  return (
    <View borderWidth={0} borderColor="red">
      {/* Barra superior */}
      <Animated.View
        style={[
          barStyle,
          {
            transform: [
              { translateY: topBarTranslateY },
              { rotate: topBarRotation },
            ],
          },
        ]}
      />

      {/* Barra do meio */}
      <Animated.View
        style={[
          barStyle,
          {
            marginTop: gap,
            opacity: middleBarOpacity,
          },
        ]}
      />

      {/* Barra inferior */}
      <Animated.View
        style={[
          barStyle,
          {
            marginTop: gap,
            transform: [
              { translateY: bottomBarTranslateY },
              { rotate: bottomBarRotation },
            ],
          },
        ]}
      />
    </View>
  )
}
